import type { FormProduct } from "@shared/types";

/**
 * Determines whether product-level fields should be locked (disabled).
 *
 * A product is locked when it has been imported from PIM/local data, or when
 * any of its variants are already imported, submitted, or pending approval.
 * This predicate is shared between the product form (to disable fields) and
 * the modal (to select the relaxed imported-product validation schema).
 *
 * Rejected variants are intentionally excluded from the isImportedRemote check:
 * a manager rejection ends the in-flight window and the vendor must be able to
 * edit and re-submit.
 */
export const isProductLevelLocked = (product: FormProduct): boolean => {
  const hasLockedVariant = product.variants?.some(
    (variant) =>
      variant.isImportedLocalVariant ||
      (variant.isImportedRemote && variant.status !== "Rejected" && variant.status !== "Draft") ||
      variant.status === "Submitted" ||
      variant.status === "Pending"
  );

  return Boolean(product.localVariants?.length || hasLockedVariant);
};
